<template>
  <div class="breadcrumbs-container">
    <div class="breadcrumbs-tabs">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="breadcrumb-item-wrapper"
      >
        <div class="breadcrumb-item">
          <router-link
            v-if="item.to && !item.active"
            :to="item.to"
            class="breadcrumb-link"
          >
            {{ item.label }}
          </router-link>
          <span v-else class="breadcrumb-text" :class="{ active: item.active }">
            {{ item.label }}
          </span>
        </div>
        <div v-if="index < items.length - 1" class="breadcrumb-separator">
          <ChevronRightIcon color="#3B4648" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { ChevronRightIcon } from "@/components/icons";

defineProps({
  items: {
    type: Array,
    required: true,
    validator: (items) => {
      return items.every(
        (item) =>
          typeof item === "object" &&
          item !== null &&
          "label" in item &&
          typeof item.label === "string"
      );
    },
  },
});
</script>

<style scoped>
.breadcrumbs-container {
  background-color: #f2f3fb;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 8px;
}

.breadcrumbs-tabs {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.breadcrumb-item-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.breadcrumb-link,
.breadcrumb-text {
  font-family: "League Spartan", sans-serif;
  font-size: var(--fs-big);
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.024px;
  color: var(--black-body-text);
  text-decoration: none;
  white-space: nowrap;
}

.breadcrumb-link:hover {
  text-decoration: underline;
}

.breadcrumb-text.active {
  font-weight: 500;
  color: var(--blue-light-1);
}

.breadcrumb-separator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
</style>
